module.exports = __webpack_public_path__ + "static/media/bstack.fdcb5431.png";